import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/entitlements/initialState.entitlements.data';
import {
  fetchEntitlementsSearchById as fetchEntitlementsSearchByIdAPI,
  fetchEntitlementsSearchGridData as fetchEntitlementsSearchGridDataAPI,
  fetchEntitlementsSiteHistoryById as fetchEntitlementsSiteHistoryAPI,
  //Search Options
  fetchAccountingGroupsData as fetchAccountingGroupsAPI,
  fetchGlobalCustomersNo as fetchGlobalCustomersNoAPI,
  fetchentitlementsCustomerSearchByName as fetchentitlementsCustomerSearchByNameAPI,
  fetchentitlementsCustomerSearch as fetchentitlementsCustomerSearchAPI,
  byMultipleInputs as byMultipleInputsAPI,
  fetchSites as fetchSiteAsPI,
  searchProductCodeName as searchProductCodeNameAPI,
  fetchEntitlementsStatus as fetchEntitlementsStatusAPI,
  fetchEntitlementsType as fetchEntitlementsTypeAPI,
} from '../../../apis/entitlementsAPI';
import {
  ENTITLEMENT_DATA,
  handlePending,
  handleRejection,
  COMMON_MESSAGE,
} from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { ACTIONS_ENTITLEMENTS } from '../../../constants/actionCreator';

//API to get data by Entitlement Id for Entitlements
export const fetchEntitlementsById = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ENTITLEMENTS_BY_ID,
  fetchEntitlementsSearchByIdAPI
);

//API to get data by Entitlement Id for Site History
export const fetchEntitlementsSiteHistoryById = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ENTITLEMENTS_SITE_HISTORY_BY_ID,
  fetchEntitlementsSiteHistoryAPI
);

//API to get data by Entitlement Search Options for Entitlement Search Grid Data
export const fetchEntitlementsSearchGridData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ENTITLEMENTS_BY_SEARCH_OPTIONS,
  fetchEntitlementsSearchGridDataAPI
);

//Search Options
//API to get data for Accounting Groups
export const fetchAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsAPI
);

//API to get data for Global Customer No
export const getSearchByCustomerId = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_GLOBAL_CUSTOMERS_NO,
  fetchGlobalCustomersNoAPI
);

//API to get data for Customer Name contains search
export const customerNameSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_PRODUCT_NAME_CONTAINS,
  fetchentitlementsCustomerSearchByNameAPI
);

//API to get data for Global Customer Data
export const getAllCustomersForParentGlobalModal = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ALL_CUSTOMERS_FOR_PARENT_GLOBAL_MODAL,
  fetchentitlementsCustomerSearchAPI
);

//API to get data for Global Customer Search by multiple inputs
export const getSearchByMultipleInputs = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.SEARCH_ALL_CUSTOMERS_BY_MULTIPLE_INPUTS,
  byMultipleInputsAPI
);

//API to get data for Sites Data
export const fetchSites = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_SITES,
  fetchSiteAsPI
);

//API to get data for Service Product
export const searchProductCodeNameData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_PRODUCT_CODE_NAME,
  searchProductCodeNameAPI
);

//API to get data for Entitlement Status
export const fetchEntitlementsStatus = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ENTITLEMENTS_STATUS,
  fetchEntitlementsStatusAPI
);

export const fetchEntitlementsType = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_ENTITLEMENTS_TYPE,
  fetchEntitlementsTypeAPI
);
//API to get data for Entitlement Type

const entitlementsSlice = createSlice({
  name: 'entitlements',
  initialState,
  reducers: {
    //Quick Search
    handleEntitlementQuickSearchId: (state, action) => {
      state.tmpentitlementsQuickSearchId = action?.payload || '';
      state.apiSuccessResponse.get = '';
    },
    //Reset
    handleReset: () => {
      return initialState;
    },

    // back to entitlement reset
    setbackToEntitlements: (state) => {
      state.isEntitlementsLoading = initialState.isEntitlementsLoading;
      state.selectededTab = initialState.selectededTab;
      state.entitlmentDetailsSelectededTab =
        initialState.entitlmentDetailsSelectededTab; //Details Tab Active State
      state.isMainScreen = initialState.isMainScreen;
      state.isAddNew = initialState.isAddNew;
      state.loading = initialState.loading;
      state.errors = {};
      state.isActiveLoading = false;
      state.isDeactiveLoading = false; // You can store the deactive loading here
      state.isResultsFound = false; // variable for result found here
      state.isEntitlementsByIdResultsFound = false; // variable for result found here
      state.isEntitlementsSearchDataResultsFound = false; // variable for result found here
      state.isEntitlementsSiteHistoryByIdResultsFound = false; // variable for result found here
      state.isAccountingGroupsResultsFound = false; // variable for result found here
      state.isSitesResultsFound = false; // variable for result found here
      state.isServiceProductResultsFound = false; // variable for result found here
      state.gCNumberLoader = false; // variable for global customer number loader here
      state.errorModal = null; // variable for error modal here
      state.noDataFound = false; // variable for no data found here
      state.alertDialog = false; // variable for alert dialog here
      state.alertText = ENTITLEMENT_DATA.errorMsg; // variable for alert text here
      state.apiSuccessResponse = initialState.apiSuccessResponse;
      state.isentitlementsSearch = true; // You can store the current page as entitlements search page here
      state.isentitlementsMain = false; // You can store the current page as entitlements main page here
      state.isEntitlementsSearchDataGridVisible = true; // You can store the entitlements search data grid visible here

      //EntitlementsData
      state.entitlementsSearchData = state.tmpentitlementsSearchData;
      state.tmpentitlementsSearchData = []; // You can store the entitlements search data here
            
      //Entitlements Site History Data
      state.entitlementsSiteHistoryData = []; // You can store the entitlements site history data here
      state.entitlementsSiteHistoryTotalCount = 0; // You can store the entitlements site history total count here
      //Filters Dates Name
      state.entitlementsSearchFilterDatesName =
        initialState.entitlementsSearchFilterDatesName;
      state.entitlementsSearchOtherFiltersNumeric =
        initialState.entitlementsSearchOtherFiltersNumeric;
      state.entitlementsSearchOtherFiltersNonNumeric =
        initialState.entitlementsSearchOtherFiltersNonNumeric;
      state.entitlementType = [];
      state.entitlementStatus = [];
      state.accountingGroupModal = initialState.accountingGroupModal;
      //Service Product Modal
      state.serviceProductModal = initialState.serviceProductModal;
      //Customers Search Modal
      state.customersSearchModal = initialState.customersSearchModal;
      state.siteNameModal = initialState.siteNameModal;
      state.selectedComponent = state.selectedComponent; // variable for selected radio component
      state.globalCustomerNo = '';
      state.dropDownValues = initialState.dropDownValues;
      state.selectedCustomerNameInputValue =
        initialState.selectedCustomerNameInputValue;
      state.parentGlobalModal = initialState.parentGlobalModal;
      state.selectedGlobalCustomerRowData = []; // You can store the selected global customer row data here
      state.name = [];
      state.inputError = null;
      state.customerNameSearchTerm = '';
      state.showCustomernameSelectedValue = null;
      state.entitlementsSearchModal = {};
      state.user = '';
      state.rqsIdfromEid = 'None';
      state.warrantyIdfromEid = null;
      state.entitlementGridLoading = false;
      if (
        state.selectedComponent ===
        ENTITLEMENT_DATA.radioButtonWithMultipleFilters
      ) {
        state.tmpentitlementsQuickSearchId =
          initialState.tmpentitlementsQuickSearchId;
        state.entitlementsQuickSearchId = state.entitlementsQuickSearchId;
      }
    },

    handleParentGlobalModalReset: (state) => {
      state.parentGlobalModal.parentGlobalModalMultipleInputs =
        initialState.parentGlobalModal.parentGlobalModalMultipleInputs;
      state.parentGlobalModal.parentGlobalModalDropDownValues =
        initialState.parentGlobalModal.parentGlobalModalDropDownValues;
      state.parentGlobalModal.showCustomernameSelectedValue =
        initialState.parentGlobalModal.showCustomernameSelectedValue;
      state.parentGlobalModal.customerNameSearchTerm =
        initialState.parentGlobalModal.customerNameSearchTerm;
      state.parentGlobalModal.parentGlobalGridData =
        initialState.parentGlobalModal.parentGlobalGridData;
      state.parentGlobalGridData =
        initialState.parentGlobalModal.parentGlobalGridData;
      state.parentGlobalGridTotalRecords =
        initialState.parentGlobalModal.parentGlobalGridTotalRecords;
      state.parentGlobalModal.parentGlobalGridTotalRecords =
        initialState.parentGlobalModal.parentGlobalGridTotalRecords;
    },
    //handle Selected Tab
    handleSelectedTab: (state, action) => {
      state.selectededTab = action?.payload;
    },
    handleDetailsSelectedTab: (state, action) => {
      state.entitlmentDetailsSelectededTab = action?.payload;
    },
    //Set API Success Response
    setAPISuccessResponse: (state, action) => {
      state.apiSuccessResponse = {
        ...state.apiSuccessResponse,
        ...action.payload,
      };
    },
    handleIsentitlementsMain: (state, action) => {
      state.isentitlementsMain = action?.payload;
    },
    handleIsentitlementsSearch: (state, action) => {
      state.isentitlementsSearch = action?.payload;
    },
    handleEntitlementsSearchDate: (state, action) => {
      state.entitlementsSearchOptions.entitlementsSearchFilterDates[
        action.payload.name
      ] = action?.payload?.value;
    },
    handleOpenParentGlobalCustomerNoModal: (state, action) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = action?.payload;
    },
    setSelectedValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs[
          action.payload.name
        ] = action?.payload?.value;
      } else {
        state.multipleInputsSelectedValues[action.payload.name] =
          action?.payload?.value;
      }
    },
    setCustomerNameInputValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs[
          action.payload.name
        ] = action?.payload?.value || '';
      } else {
        state.selectedCustomerNameInputValue[action.payload.name] =
          action?.payload?.value || '';
      }
    },
    setDropDownValue: (state, action) => {
      //dropdown will always have value
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalDropDownValues[
          action.payload.name
        ] = action?.payload?.value;
      } else {
        state.dropDownValues[action.payload.name] = action?.payload?.value;
      }
    },
    setSelectedAccountGridRowsData: (state, action) => {
      state.accountingGroupModal.gridAccountingRowSelectedData = action?.payload
        ? action?.payload
        : [];
      state.accountingGroupModal.gridAccountingRowSelectedCount =
        action?.payload?.length || 0;
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroupName =
          action?.payload[0]?.name || '';
        state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
          action?.payload[0]?.accountingGroupCode?.trim() || '';
      } else {
        state.multipleInputsSelectedValues.accountingGroupName =
          action?.payload[0]?.name || '';
        state.multipleInputsSelectedValues.accountingGroup =
          action?.payload[0]?.accountingGroupCode?.trim() || '';
      }
    },
    setSelectedComponent: (state, action) => {
      state.selectedComponent = action.payload ? action.payload : '';
      state.globalCustomerNo = initialState.globalCustomerNo;
      state.multipleInputsSelectedValues =
        initialState.multipleInputsSelectedValues;
      state.dropDownValues = initialState.dropDownValues;
      state.name = initialState.name;
      if (
        state.selectedComponent ===
        ENTITLEMENT_DATA.radioButtonWithMultipleFilters
      ) {
        state.entitlementsQuickSearchId =
          initialState.entitlementsQuickSearchId;
        state.tmpentitlementsQuickSearchId =
          initialState.tmpentitlementsQuickSearchId;
        state.entitlementsQuickSearchId =
          initialState.entitlementsQuickSearchId;
      }

      if (
        state.selectedComponent === ENTITLEMENT_DATA.radioButtonWithSingleFilter
      ) {
        state.entitlementsSearchData = initialState.entitlementsSearchData;
        state.tmpentitlementsSearchData =
          initialState.tmpentitlementsSearchData;
        state.entitlementSearchDataGridTotalRecords =
          initialState.entitlementSearchDataGridTotalRecords;
        state.tmpentitlementsQuickSearchId =
          initialState.tmpentitlementsQuickSearchId;
        state.entitlementsQuickSearchId =
          initialState.entitlementsQuickSearchId;
      }
    },
    setAccountingGroupModalOpen: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = true;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
    },
    setAccountingGroupModalClose: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = false;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
    },
    setParentGlobalCustomerNoModalOpen: (state) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = true;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
      state.parentGlobalModal.parentGlobalModalMultipleInputs =
        initialState.parentGlobalModal.parentGlobalModalMultipleInputs;
    },
    setParentGlobalCustomerNoModalClose: (state) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = false;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
      state.parentGlobalModal.parentGlobalModalMultipleInputs =
        initialState.parentGlobalModal.parentGlobalModalMultipleInputs;
    },
    setCustomerNameSearchTerm: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.customerNameSearchTerm = action?.payload
          ? action?.payload
          : '';
      } else {
        state.customerNameSearchTerm = action?.payload ? action?.payload : '';
      }
    },
    setCustomersGridPageSize: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs.recordCount =
          action?.payload ? action?.payload : 0;
      } else {
        state.multipleInputsSelectedValues.recordCount = action?.payload
          ? action?.payload
          : 0;
      }
    },
    setShowCustomernameSelectedValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.showCustomernameSelectedValue = action?.payload
          ? action?.payload
          : null;
      } else {
        state.showCustomernameSelectedValue = action?.payload
          ? action?.payload
          : null;
      }
    },
    setAccouningGroupFormFeilds: (state, action) => {
      state.accountingGroupModal.accountingGroupSearchForm[
        action.payload.name
      ] = action?.payload?.value || '';
    },
    setSelectedParentGlobalGridRowsData: (state, action) => {
      state.parentGlobalModal.gridParentGlobalCustomerNoRowSelectedData =
        action?.payload ? action?.payload : [];
      state.parentGlobalModal.gridParentGlobalGridRowSelectedCount =
        action?.payload?.length || 0;
      state.multipleInputsSelectedValues.parentPsCustomerCode =
        action?.payload[0]?.psCustomerCode.trim() || '';
      state.entitlementsSearchOptions.customerId =
        action?.payload[0]?.psCustomerCode.trim() || '';
    },
    assignEntitlementsSearchOptionValues: (state, action) => {
      state.entitlementsSearchOptions[action.payload.name] =
        action?.payload?.value || '';
    },
    //Service Product
    setServiceProduct: (state, action) => {
      state.serviceProductModal.serviceProductField = action?.payload
        ? action?.payload
        : '';
    },
    setServiceModalData: (state, action) => {
      const {
        id,
        erpServiceProductId,
        serviceProductCode,
        serviceProductName,
      } = action.payload
        ? action.payload
        : initialState.serviceProductModal.serviceModalData;
      state.serviceProductModal.serviceModalData = {
        ...state.serviceProductModal.serviceModalData,
        id,
        erpServiceProductId,
        serviceProductCode,
        serviceProductName,
      };

      state.entitlementsSearchOptions.erpServiceProductName =
        action?.payload?.serviceProductName ||
        initialState.entitlementsSearchOptions.erpServiceProductName;
      state.entitlementsSearchOptions.erpServiceProductId =
        action?.payload?.erpServiceProductId ||
        initialState.entitlementsSearchOptions.erpServiceProductId;
    },
    setOpenServiceProductModal: (state) => {
      state.serviceProductModal.openServiceProductModal = true;
      state.serviceProductModal.codeField =
        initialState.serviceProductModal.codeField;
      state.serviceProductModal.nameField =
        initialState.serviceProductModal.nameField;
    },
    setCloseServiceProductModal: (state) => {
      state.serviceProductModal.openServiceProductModal = false;
      resetModalFields(state);
    },
    resetModalFields: (state) => {
      state.serviceProductModal.codeField =
        initialState.serviceProductModal.codeField;
      state.serviceProductModal.nameField =
        initialState.serviceProductModal.nameField;
      state.serviceProductModal.searchProductCodeNameResult =
        initialState.serviceProductModal.searchProductCodeNameResult;
    },
    setServiceProductCode: (state, action) => {
      state.serviceProductModal.codeField = action?.payload
        ? action?.payload
        : '';
    },
    setOpenSiteModal: (state, action) => {
      state.siteNameModal.openSiteModal = action?.payload;
    },
    //Site
    setSelectedSiteGridRowsData: (state, action) => {
      state.siteNameModal.gridSiteRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : ENTITLEMENT_DATA.inputModalDefaultVal;
      state.siteNameModal.gridSiteRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.entitlementsSearchOptions.siteName = action?.payload[0]?.name
        ? action?.payload[0].name
        : '';
      state.entitlementsSearchOptions.siteId = action?.payload[0]?.id
        ? action?.payload[0].id
        : 0;
      state.siteNameModal.openSiteModal = false;
    },
    setSiteFormFeilds: (state, action) => {
      state.siteNameModal.siteSearchForm[action.payload.name] =
        action?.payload?.value;
    },
    handleFilteredSiteData: (state, action) => {
      state.siteNameModal.siteSearchData =
        action?.payload?.length > 0 ? action?.payload : [];
    },
    handleEntitlementType: (state, action) => {
      state.entitlementsSearchOptions.entitlementTypeId =
        action?.payload?.value || 0;
    },
    handleHistoryType: (state, action) => {
      state.entitlementsSearchOptions.contractHistoryTypeId =
        action?.payload?.value || 0;
    },
    handleEntitlementStatus: (state, action) => {
      state.entitlementsSearchOptions.entitlementStatusId =
        action?.payload?.value || 0;
    },
    setOpenAlertBox: (state) => {
      state.alertDialog = true;
    },
    setCloseAlertBox: (state) => {
      state.alertDialog = false;
    },
    setAlertMessage: (state, action) => {
      state.alertText = action?.payload;
    },
    resetFiltersSearchOptionsData: (state) => {
      state.entitlementsSearchOptions = initialState.entitlementsSearchOptions;
      state.entitlementsSearchData = initialState.entitlementsSearchData;
      state.isEntitlementsSearchDataGridVisible = false;
      state.multipleInputsSelectedValues =
        initialState.multipleInputsSelectedValues;
    },
    warrantyHandleSaveClose: (state, action) => {
      state.entitlementsQuickSearchId = action?.payload;
    },

    setOnAccountGChange: (state, action) => {
      state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
        action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntitlementsById.pending, (state, action) => {
        handlePending(state, action);
        if (state.apiSuccessResponse.get === '') {
          state.tmpentitlementsSearchData = state.entitlementsSearchData;
        }
        state.isEntitlementsByIdResultsFound = null;
        state.isEntitlementsLoading = true;
        state.rqsIdfromEid = null;
        state.warrantyIdfromEid = null;
      })
      .addCase(fetchEntitlementsById.fulfilled, (state, action) => {
        state.loading = false;
        state.apiSuccessResponse.get =
          action?.payload === null || action?.payload?.length === 0
            ? 'error'
            : 'success';
        if (state.apiSuccessResponse.get === 'success') {
          state.entitlementsQuickSearchId = state.tmpentitlementsQuickSearchId
            ? state.tmpentitlementsQuickSearchId
            : action?.payload?.entitlementId;
          state.entitlementsSearchData = action?.payload
            ? action?.payload
            : state.entitlementsSearchData;
          state.isEntitlementsByIdResultsFound = action?.payload?.length === 0;
          state.rqsIdfromEid = action?.payload?.warrantyPartNumber
            ? action?.payload?.warrantyPartNumber
            : COMMON_MESSAGE.none;
          state.warrantyIdfromEid = action?.payload?.warrantyId
            ? action?.payload?.warrantyId
            : null;
          state.isentitlementsMain = true; //To entitlements Main page
          state.isentitlementsSearch = false; //To entitlements Search Options page

          state.isEntitlementsLoading = false;

          state.entitlementsSiteHistoryData =
            initialState.entitlementsSiteHistoryData; //To clear the existing data from Site History Grid
        } else {
          state.tmpentitlementsQuickSearchId = state.entitlementsQuickSearchId;
          state.entitlementsSearchData = state.tmpentitlementsSearchData;
          state.isEntitlementsLoading = false;
        }
      })
      .addCase(fetchEntitlementsById.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.isEntitlementsByIdResultsFound = true;
        state.isEntitlementsLoading = false;
        state.apiSuccessResponse.get = 'error';
        if (state.apiSuccessResponse.get === 'error') {
          state.tmpentitlementsQuickSearchId = state.entitlementsQuickSearchId;
        }
        state.rqsIdfromEid = null;
        state.warrantyIdfromEid = null;
      })

      .addCase(fetchEntitlementsSearchGridData.pending, (state, action) => {
        handlePending(state, action);
        state.isEntitlementsSearchDataGridVisible = true;
        state.entitlementsSearchData = [];
        state.isEntitlementsSearchDataResultsFound = null;
        state.entitlementGridLoading = true;
      })
      .addCase(fetchEntitlementsSearchGridData.fulfilled, (state, action) => {
        state.loading = false;
        state.apiSuccessResponse.get =
          action.payload?.length === 0 ? 'error' : 'success';
        state.isEntitlementsSearchDataGridVisible = true;
        if (state.apiSuccessResponse.get === 'success') {
          state.entitlementsSearchData = action?.payload ? action?.payload : [];
          state.entitlementSearchDataGridTotalRecords = action?.payload
            ? action?.payload[0].totalRecords
            : 0;
          state.isEntitlementsSearchDataResultsFound =
            action?.payload?.length === 0;
          state.entitlementsSiteHistoryData =
            initialState.entitlementsSiteHistoryData; //To clear the existing data from Site History Grid
        } else {
          state.entitlementsSearchData = [];
          state.isEntitlementsSearchDataResultsFound = true;
          state.entitlementSearchDataGridTotalRecords = 0;
        }
        state.entitlementGridLoading = false;
      })
      .addCase(fetchEntitlementsSearchGridData.rejected, (state, action) => {
        handleRejection(state, action);
        state.isEntitlementsSearchDataGridVisible = true;
        state.isEntitlementsSearchDataResultsFound = true;
        state.apiSuccessResponse.get =
          action?.payload?.length === 0 ? 'error' : 'success';
        state.apiSuccessResponse.get = 'error';
        if (state.apiSuccessResponse.get === 'error') {
          state.entitlementsSearchData = [];
        }
        state.entitlementGridLoading = false;
      })

      .addCase(fetchEntitlementsSiteHistoryById.pending, (state, action) => {
        handlePending(state, action);
        state.isEntitlementsSiteHistoryByIdResultsFound = null;
      })
      .addCase(fetchEntitlementsSiteHistoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.entitlementsSiteHistoryData =
          action?.payload?.entitlementSites.map((item, index) => ({
            rowIndex: index,
            ...item,
          })) || [];
        state.isEntitlementsSiteHistoryByIdResultsFound =
          action?.payload?.length === 0;
        state.entitlementsSiteHistoryTotalCount =
          action?.payload?.totalRecords || 0;
      })
      .addCase(fetchEntitlementsSiteHistoryById.rejected, (state, action) => {
        handleRejection(state, action);
        state.isEntitlementsSiteHistoryByIdResultsFound = true;
      })

      //Search Options
      .addCase(customerNameSmartSearchData.pending, (state) => {
        state.inputError = null;
      })
      .addCase(customerNameSmartSearchData.fulfilled, (state, action) => {
        if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
          action?.payload?.length > 0
            ? (state.parentGlobalModal.name = action?.payload)
            : (state.parentGlobalModal.name = []);
        } else {
          action?.payload?.length > 0
            ? (state.name = action?.payload)
            : (state.name = []);
        }
      })
      .addCase(customerNameSmartSearchData.rejected, (state, action) => {
        state.inputError = action?.payload;
      })

      .addCase(fetchAccountingGroups.pending, (state) => {
        state.isAccountingGroupsResultsFound = null;
        state.loading = true;
      })
      .addCase(fetchAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.accountingGroups?.length > 0) {
          state.accountingGroupModal.accountingGroups =
            action?.payload?.accountingGroups || [];
          state.accountingGroupModal.accountingGroupSearchData =
            action?.payload?.accountingGroups || [];
          state.accountingGroupModal.accountingGroupGridTotalRecords =
            action?.payload?.totalCount || 0;
          state.isAccountingGroupsResultsFound =
            action?.payload?.accountingGroups?.length === 0;
        } else {
          state.accountingGroupModal.accountingGroups = [];
          state.accountingGroupModal.accountingGroupSearchData = [];
          state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
          state.isAccountingGroupsResultsFound = true;
        }
      })
      .addCase(fetchAccountingGroups.rejected, (state) => {
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.accountingGroupModal.accountingGroups = [];
        state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
        state.loading = false;
      })

      .addCase(getSearchByCustomerId.pending, (state) => {
        state.gCNumberLoader = true;
        state.errorModal = null;
        state.searchResult = [];
        state.selectedGlobalCustomerRowData = [];
      })
      .addCase(getSearchByCustomerId.fulfilled, (state, action) => {
        state.gCNumberLoader = false;
        if (action.payload) {
          state.selectedGlobalCustomerRowData = action?.payload
            ? action?.payload
            : [];
          state.errorModal = null;
          state.displayButtonValue = true;
        } else {
          state.selectedGlobalCustomerRowData = [];
          state.errorModal = action?.meta?.arg || 'enterValue';
          state.displayButtonValue = false;
        }
      })
      .addCase(getSearchByCustomerId.rejected, (state, action) => {
        state.gCNumberLoader = false;
        state.errorModal = action?.meta?.arg || 'enterValue';
      })

      .addCase(getAllCustomersForParentGlobalModal.pending, (state) => {
        state.loading = true;
        state.parentGlobalModal.parentGlobalGridData = [];
        state.parentGlobalModal.isParentGlobalResultsFound = null;
      })
      .addCase(
        getAllCustomersForParentGlobalModal.fulfilled,
        (state, action) => {
          state.loading = false;
          if (action?.payload?.length > 0) {
            state.parentGlobalModal.parentGlobalGridData =
              action?.payload?.sort((a, b) => a.name - b.name);
            state.parentGlobalModal.parentGlobalGridTotalRecords =
              action?.payload ? action?.payload[0]?.totalRecords : 0;
            state.parentGlobalModal.isParentGlobalResultsFound =
              action?.payload?.length === 0;
          } else {
            state.parentGlobalModal.parentGlobalGridData = [];
            state.parentGlobalModal.parentGlobalGridTotalRecords = 0;
            state.parentGlobalModal.isParentGlobalResultsFound = true;
          }
        }
      )
      .addCase(
        getAllCustomersForParentGlobalModal.rejected,
        (state, action) => {
          state.loading = false;
          state.inputError = action.payload;
          state.parentGlobalModal.parentGlobalGridTotalRecords = 0;
          state.parentGlobalModal.isParentGlobalResultsFound = true;
        }
      )

      .addCase(getSearchByMultipleInputs.pending, (state) => {
        state.loading = true;
        state.customersSearchModal.inputError = null;
        state.customersSearchModal.searchResult = [];
        state.customersSearchModal.customersGridselectedRowData = [];
        state.customersSearchModal.customersGridResultsFound = null;
      })
      .addCase(getSearchByMultipleInputs.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.length > 0) {
          state.customersSearchModal.searchResult = action?.payload?.sort(
            (a, b) => a.name - b.name
          );
          state.customersSearchModal.customersGridTotalRecords = action?.payload
            ? action?.payload[0]?.totalRecords
            : 0;
          state.customersSearchModal.customersGridResultsFound =
            action?.payload?.length === 0;
        } else {
          state.customersSearchModal.searchResult = [];
          state.customersSearchModal.customersGridTotalRecords = 0;
          state.customersSearchModal.customersGridResultsFound = true;
        }
      })
      .addCase(getSearchByMultipleInputs.rejected, (state, action) => {
        state.loading = false;
        state.customersSearchModal.inputError = action?.payload
          ? action?.payload
          : null;
        state.customersSearchModal.customersGridTotalRecords = 0;
        state.customersSearchModal.customersGridResultsFound = true;
      })

      .addCase(fetchSites.pending, (state) => {
        state.siteNameModal.siteSearchData = [];
        state.isSitesResultsFound = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.loading = false;
        state.siteNameModal.sites = action?.payload?.sites;
        state.siteNameModal.siteSearchData = action?.payload?.sites;
        state.siteNameModal.siteGridTotalRecords = action?.payload?.sites
          ? action?.payload?.sites[0]?.totalRecords
          : 0;
        state.isSitesResultsFound = action?.payload?.sites?.length === 0;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        handleRejection(state, action);
        state.siteNameModal.siteSearchData = [];
        state.siteNameModal.siteGridTotalRecords = 0;
        state.isSitesResultsFound = true;
      })

      .addCase(searchProductCodeNameData.pending, (state) => {
        state.serviceProductModal.searchProductCodeNameLoading = true;
        state.serviceProductModal.searchProductCodeNameResult = [];
        state.isServiceProductResultsFound = null;
      })
      .addCase(searchProductCodeNameData.fulfilled, (state, action) => {
        state.serviceProductModal.searchProductCodeNameLoading = false;
        state.serviceProductModal.searchProductCodeNameResult = action?.payload
          ? action?.payload
          : [];
        state.isServiceProductResultsFound = action?.payload?.length === 0;
        state.serviceProductModal.searchProductCodeNameTotalRecords =
          action?.payload ? action?.payload[0]?.totalRecords : 0;
      })
      .addCase(searchProductCodeNameData.rejected, (state) => {
        state.serviceProductModal.searchProductCodeNameLoading = false;
        state.serviceProductModal.searchProductCodeNameResult = [];
        state.isServiceProductResultsFound = true;
        state.serviceProductModal.searchProductCodeNameTotalRecords = 0;
      })

      .addCase(fetchEntitlementsStatus.pending, (state) => {
        state.loading = true;
        state.entitlementStatus = [];
      })
      .addCase(fetchEntitlementsStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.entitlementStatus = action.payload ? action.payload : [];
      })
      .addCase(fetchEntitlementsStatus.rejected, (state) => {
        state.loading = false;
        state.entitlementStatus = [];
      })

      .addCase(fetchEntitlementsType.pending, (state) => {
        state.loading = true;
        state.entitlementType = [];
      })
      .addCase(fetchEntitlementsType.fulfilled, (state, action) => {
        state.loading = false;
        state.entitlementType = action.payload ? action.payload : [];
      })
      .addCase(fetchEntitlementsType.rejected, (state) => {
        state.loading = false;
        state.entitlementType = [];
      });
  },
});

export const {
  setAlertMessage,
  setOpenAlertBox,
  setCloseAlertBox,
  handleEntitlementQuickSearchId,
  handleParentGlobalModalReset,
  handleReset,
  setbackToEntitlements,
  handleSelectedTab,
  handleDetailsSelectedTab,
  setAPISuccessResponse,
  handleIsentitlementsMain,
  handleIsentitlementsSearch,
  handleEntitlementsSearchDate,
  handleOpenParentGlobalCustomerNoModal,
  resetFiltersSearchOptionsData,
  //Search Options
  setSelectedValue,
  setCustomerNameInputValue,
  setDropDownValue,
  setSelectedAccountGridRowsData,
  setSelectedComponent,
  setAccountingGroupModalOpen,
  setAccountingGroupModalClose,
  setParentGlobalCustomerNoModalOpen,
  setParentGlobalCustomerNoModalClose,
  setCustomerNameSearchTerm,
  setCustomersGridPageSize,
  setShowCustomernameSelectedValue,
  setAccouningGroupFormFeilds,
  setSelectedParentGlobalGridRowsData,
  assignEntitlementsSearchOptionValues,
  //Service Product
  setServiceProduct,
  setServiceModalData,
  setOpenServiceProductModal,
  setCloseServiceProductModal,
  setServiceProductCode,
  resetModalFields,
  //Site
  setOpenSiteModal,
  setSelectedSiteGridRowsData,
  handleFilteredSiteData,
  setSiteFormFeilds,
  //SiteType
  handleEntitlementType,
  handleHistoryType,
  //Status
  handleEntitlementStatus,
  //warrantyInfo
  warrantyHandleSaveClose,
  setOnAccountGChange,
} = entitlementsSlice.actions;

export default entitlementsSlice.reducer;
